import { render, staticRenderFns } from "./IntroRobo.vue?vue&type=template&id=cc6b144e&scoped=true&"
import script from "./IntroRobo.vue?vue&type=script&lang=js&"
export * from "./IntroRobo.vue?vue&type=script&lang=js&"
import style0 from "./IntroRobo.vue?vue&type=style&index=0&id=cc6b144e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6b144e",
  null
  
)

export default component.exports